
  import { PaymentMethods } from '../../'
  export default {
    components: { PaymentMethods },
    props: {
        user: {
            required: true
        }
    },
    data: () => ({
        selectedPaymentMethod: -1,
        paymentMethods: null,
        loading: false
    }),
    methods: {
        setSelected(method) {
            this.selectedPaymentMethod = method
            this.$store.commit('payment/setSelectedPaymentMethod', method)
        },
    },
    beforeDestroy() {
        this.$store.commit('payment/setSelectedPaymentMethod', null)
    }
}
  